import React from 'react';
import { CollectionBannerProps } from './collection-banner-types';
import {
  BannerContainer,
  BannerSection,
  BannerImage,
  ThumbnailWrapper,
} from './style-component';

const CollectionBanner: React.FC<CollectionBannerProps> = ({
  name,
  banner_url,
  thumb_url,
}) => {

  return (
    <BannerContainer>
      <BannerSection>
        <BannerImage src={banner_url} alt={`${name} banner`} />
        <ThumbnailWrapper>
          <img src={thumb_url} alt={`${name} thumbnail`} />
        </ThumbnailWrapper>
      </BannerSection>
    </BannerContainer>
  );
};

export default CollectionBanner;